import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { RegistrarAseguradoraPage } from './registrar-aseguradora.page';

const routes: Routes = [
  {
    path: '',
    component: RegistrarAseguradoraPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [RegistrarAseguradoraPage]
})
export class RegistrarAseguradoraPageModule {}
